import { flagSvIcon } from "./flags";
import { keyFilter, formatInput } from "./formatter";
import { TFormatInput } from "./formatter";

type TPhonesFormatter = {
  [key: string]: {
    formatMask: string;
    flagIcon: JSX.Element;
    countryPrefix: string;
    keyFilter: (event: React.KeyboardEvent<HTMLInputElement>, formatMask: string, countryPrefix: string) => void;
    formatInput: (formattedValue: string, selectionStart: number, formatMask: string) => TFormatInput;
  };
};

//Format protected places +0...1, X - any number, N - any number except 0

export const phonesFormatter: TPhonesFormatter = {
  sv: {
    formatMask: "+46 NXX XXX XXX",
    flagIcon: flagSvIcon,
    countryPrefix: "+46",
    keyFilter,
    formatInput,
  },
};
